"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _Types = require("../../util/Types");
var _Dataformat = require("../../util/Dataformat");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
* dataformat view for file size (byte, MB, GB)
* or other data format column as required
*/
var CellView = function CellView(_ref) {
  var column = _ref.column,
    row = _ref.row;
  var dataFormatType = column.dataFormatType;
  var value = row[column === null || column === void 0 ? void 0 : column.dataField];
  switch (dataFormatType) {
    case _Types.dataFormatTypes.FORMAT_BYTES:
      return /*#__PURE__*/_react.default.createElement(_core.Typography, null, (0, _Dataformat.formatBytes)(value));
    default:
      return /*#__PURE__*/_react.default.createElement(_core.Typography, null, value);
  }
};
var DataFormatView = function DataFormatView(_ref2) {
  var column = _ref2.column,
    row = _ref2.row;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CellView, {
    column: column,
    row: row
  }));
};
var _default = DataFormatView;
exports.default = _default;